export const languageMap = {
  en: 'english',
  fr: 'french',
  es: 'spanish',
  de: 'german',
  no: 'norwegian',
  zh: 'chinese',
  ja: 'japanese',
  jp: 'japanese',
};
